export default "__VITE_ASSET__B300cOV$__"